// ServMarketData.js
export const ServMarketTopImg = [
  {
    id: 0,
    image: require('../images/ServiceImg/MarketTop/MarketAerospace.png'),
    alt: 'images/ServiceImg/MarketTop/MarketAerospace.png',
  },
  {
    id: 1,
    image: require('../images/ServiceImg/MarketTop/MarketMedical.png'),
    alt: 'images/ServiceImg/MarketTop/MarketMedical.png',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/MarketTop/MarketPos.png'),
    alt: 'images/ServiceImg/MarketTop/MarketPos.png',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/MarketTop/MarketIndustrial.png'),
    alt: 'images/ServiceImg/MarketTop/MarketIndustrial.png',
  },
  {
    id: 4,
    image: require('../images/ServiceImg/MarketTop/MarketTranspotation.png'),
    alt: 'images/ServiceImg/MarketTop/MarketTranspotation.png',
  },
  {
    id: 5,
    image: require('../images/ServiceImg/MarketTop/MarketMilitary.png'),
    alt: 'images/ServiceImg/MarketTop/MarketMilitary.png',
  },
  {
    id: 6,
    image: require('../images/ServiceImg/MarketTop/MarketAerospace.png'),
    alt: 'images/ServiceImg/MarketTop/MarketAerospace.png',
  },
  {
    id: 7,
    image: require('../images/ServiceImg/MarketTop/MarketPos.png'),
    alt: 'images/ServiceImg/MarketTop/MarketPos.png',
    // link: 'https://touchinternational.com/applications/#top',
  },
]

export const ServMarketTopTxt = [
  {
    id: 0,
    // image: require('../images/ServiceImg/MarketTouch.png'),
    // alt: 'images/ServiceImg/Market/MarketTouch.png',
    name: 'Building The Best Touch Panel',
    title: 'HLZ打造最佳触控面板',
    subtitle: '適用於高可靠性應用的触控面板解決方案',
    text:
      '                                                ' +
      '全场景触控解决方案：赋能未来产业升级\n' +
      '合利资作为全球领先的触摸屏面板制造商，我们深耕人机交互技术领域，以创新驱动为核心，' +
      '为航空航天、工业控制、智能家居、交通运输、POS零售、医疗及教育等行业提供定制化触控解决方案，' +
      '满足严苛环境下的高性能需求，\n' +
      '\n',
    // nameEng: 'Building Better Touch Panel',
    // titleEng: 'HLZ Building Better Touch Panel',
    // subtitleEng: 'Touchscreen Solutions for High-Reliability Applications',
    // textEng:
    //      'Engineering advanced touch-enabled products for peak performance in rugged and professional environments while meeting or exceeding regulatory compliances and quality assurance.' +
    //      'HLZ Technology’s expert engineering, design, and manufacturing teams in the U.S., China, and India are well-equipped to deliver on the company’s capabilities of high-mix, low-volume production with rapid prototyping.' +
    //      'Additionally, our facilities boast Class 10,000 cleanrooms, ensuring products meet the uncompromising quality demands required in high-reliability applications.' +
    //      'Our commitment to building industry-reliable products complies with stringent ITAR, AS9100, ISO9001, and ISO13485 standards.',
    // describe: 'ServMarketTopTxt',
    // link: 'https://touchinternational.com/applications/#top',
    time: '2025/2/13',
  },
]

export const ServMarketImg = [
  {
    id: 1,
    image: require('../images/ServiceImg/Market/Aerospace.png'),
    alt: 'images/ServiceImg/Market/Aerospace.png',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/Market/Medical.png'),
    alt: 'images/ServiceImg/Market/Medical.png',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/Market/Pos.png'),
    alt: 'images/ServiceImg/Market/Pos.png',
  },
  {
    id: 4,
    image: require('../images/ServiceImg/Market/Industrial.png'),
    alt: 'images/ServiceImg/Market/Industrial.png',
    // alt: 'images/ServiceImg/Market/MarketIndustrial.png',
  },
  {
    id: 5,
    image: require('../images/ServiceImg/Market/Transportation.png'),
    alt: 'images/ServiceImg/Market/Transportation.png',
  },
  {
    id: 6,
    image: require('../images/ServiceImg/Market/Military.png'),
    alt: 'images/ServiceImg/Market/Military.png',
    // alt: 'images/ServiceImg/Market/MarketMilitary.png',
  },
  {
    id: 7,
    image: require('../images/ServiceImg/Market/Consumer.png'),
    alt: 'images/ServiceImg/Market/Consumer.png',
    // alt: 'images/ServiceImg/Market/MarketAerospace.png',
  },
  {
    id: 8,
    image: require('../images/ServiceImg/Market/SmartHome.png'),
    alt: 'images/ServiceImg/Market/SmartHome.png',
    // alt: 'images/ServiceImg/Market/MarketPos.png',
  },
  {
    id: 9,
    image: require('../images/ServiceImg/Market/Education.png'),
    alt: 'images/ServiceImg/Market/Education.png',
    // link: 'https://touchinternational.com/applications/#top',
  },
]

export const ServMarketTxt = [
  {
    id: 0,
    // image: require('../images/ServiceImg/Market/MarketTranspotation.png'),
    // alt: 'images/ServiceImg/Market/MarketTranspotation.png',
    name: ' ',
    title: ' ',
    subtitle: ' ',
    text:
      '在科技高速发展的时代，投射式电容触摸屏广泛应用于消费电子产品、汽车电子、零售业、\n' +
      ' 医疗设备、工业控制、军事领域、机器人、通讯设备、安防、智能家居、能源等领域，\n' +
      ' 在多个场景为人类提供优秀的体验以及高效的服务\n' +
      ' ',
    time: '2025/2/13',
  },
  {
    id: 1,
    // image: require('../images/ServiceImg/Market/MarketTranspotation.png'),
    // alt: 'images/ServiceImg/Market/MarketTranspotation.png',
    name: 'Transportation Touch Panel Solutions',
    title: '交通运输/汽车电子解决方案',
    subtitle: '交通运输/汽車電子：安全可视，畅行无阻',
    text:
      '交通运输/汽車電子：安全可视，畅行无阻\n' +
      '  在车载娱乐，安全系统，充电桩，轨道交通等应用中，触摸屏在阳光下清晰可视、\n' +
      '     阻止刺眼的光线，在碰撞时的防爆设计以及兼容不同电压下的稳定性是车辆行驶中\n' +
      '     保障安全的核心部件\n' +
      '  HLZ通过结合高透光率AG玻璃与光学贴合技术，消除反光干扰，阳光下可视、抗眩光；\n' +
      '     通过车规级AEC-Q100认证，支持-30℃至+105℃宽温运行，适配车载中控、充电桩、\n' +
      '     轨道交通导览系统，为您提供安全舒适的出行体验\n' +
      ' ',
    time: '2025/12/11',
  },
  {
    id: 2,
    // image: require('../images/ServiceImg/Market/MarketPos.png'),
    // alt: 'images/ServiceImg/Market/MarketPos.png',
    name: 'Retail and POS Touch Display Solutions',
    title: '零售/POS触控面板解決方案',
    subtitle: '高效交互，驱动商业增长',
    text:
      'POS零售：高效交互，驱动商业增长\n' +
      '  在POS零售的应用核心需求：触摸屏防刮耐磨、表面电镀抗菌涂层、触摸动作的快速响应\n' +
      '     已经成为许多客户的首要选择\n' +
      '  HLZ通过研发高规格钢化玻璃表面硬度达9H，经过百万次常规触模验证无磨损；\n' +
      '     银离子抗菌层能够有效抑制病菌滋生，高灵敏度的触摸方案适配自助收银机、\n' +
      '     智能货架及餐饮点餐终端，提升消费体验与运营效率\n' +
      ' ',
  },
  {
    id: 3,
    // image: require('../images/ServiceImg/Market/MarketMedical.png'),
    // alt: 'images/ServiceImg/MarketMedical.png',
    name: 'Medical Touch Screen & Touch Display Solutions',
    title: '醫療触控面板解決方案',
    subtitle: '精准无菌，守护生命健康',
    text:
      '医疗设备：精准无菌，守护生命健康\n' +
      '  医疗设备应用核心需求：高精度的触摸屏可以减少误操作，抗消毒液腐蚀、防液体渗透\n' +
      '     及易清洁等都能够提升医疗设备的使用寿命\n' +
      '  HLZ设计的全密封结构触摸屏能够有效防止液体渗入，支持戴医用手套操作；\n' +
      '     采用抗菌玻璃与防液体误触算法提高触摸精度，适配手术台控制面板、医疗影像设备\n' +
      '     及远程诊断终端\n' +
      ' ',
  },
  {
    id: 4,
    // image: require('../images/ServiceImg/Market/MarketIndustrial.png'),
    // alt: 'images/ServiceImg/Market/MarketIndustrial.png',
    name: 'Industrial Touch Screen Display Solutions',
    title: '工業控制控制触控面板解決方案',
    subtitle: '坚固耐用，赋能智造升级',
    text:
      '工业控制: 坚固耐用，引导智造升级\n' +
      '  在复杂的工业控制环境核心需求：IP65/IP67防护等级、抗油污腐蚀、长寿命、\n' +
      '     兼容多协议的触摸屏是保障工业设备稳定运行，正常控制的关键部件\n' +
      '  HLZ通过先进的全贴合工艺结合防刮纳米涂层，在抵御粉尘、油渍及化学腐蚀上\n' +
      '     拥有专业的解决方案；在触摸屏的控制电路上，支持工业级PLC协议与多节点触控，\n' +
      '     为适配重型机械HMI、自动化产线控制台等工业控制设备触摸屏24小时\n' +
      '     不间断运行提供强力的保障\n' +
      ' ',
  },
  {
    id: 5,
    // image: require('../images/ServiceImg/Market/MarketIndustrial.png'),
    // alt: 'images/ServiceImg/Market/MarketIndustrial.png',
    name: '智能家居',
    title: '智能家居触控面板解決方案',
    subtitle: '美学与性能的完美平衡',
    text:
      '智能家居/安防：美学与性能的完美平衡\n' +
      '  智能化的家居产品里，触摸面板的超薄设计、低功耗、高灵敏多点触控、语音交互，\n' +
      '     是实现家庭智慧生态提供美观与高效的重要部件之一\n' +
      '  HLZ通过设计窄边框电容屏搭配OLED显示屏，实现无死角触控响应；\n' +
      '     内置低功耗芯片与抗干扰算法，无缝接入智能家居生态，打造客厅中控、\n' +
      '     智能门锁等场景的沉浸式交互体验\n' +
      ' ',
  },
  {
    id: 6,
    // image: require('../images/ServiceImg/Market/MarketAerospace.png'),
    // alt: 'images/ServiceImg/Market/MarketAerospace.png',
    name: 'Aerospace Touch Screen Display Solutions',
    title: '航空航天触控面板解決方案',
    subtitle: '极致可靠，征服极端环境',
    text:
      '航空航天: 极致可靠，征服极端环境\n' +
      '  坚固耐用要求：在航空航天的过程中，对触控面板抗冲击，高低空域变化的剧烈温域差异\n' +
      '     (-40℃至85℃)，阳光直射面板高亮度的可视性，以及在复杂抗电磁干扰(EMI/RFI)环境下\n' +
      '     有较高的要求\n' +
      '  HLZ通过采用强化玻璃基板与光学贴合技术，确保面板在剧烈震动、极端温差及\n' +
      '     强光直射下稳定运行；通过MIL-STD军工级认证，支持手套及湿手操作，满足驾驶舱、\n' +
      '     航电系统等关键应用场景下触摸屏的可靠性和稳定性\n' +
      ' ',
    describe: 'ServMarketData',
    time: '2025/12/11',
  },
  {
    id: 7,
    image: require('../images/ServiceImg/Market/MarketEducation.png'),
    alt: 'images/ServiceImg/Market/MarketEducation.png',
    name: 'Education Touch Screen & Touch Display Solutions',
    title: '教育领域触控面板解決方案',
    subtitle: '极致可靠，征服极端环境',
    text:
      '教育领域：互动创新，激发学习潜能\n' +
      '  在教育设备的应用核心需求：触摸面板防摔防撞、支持抗压笔书写、\n' +
      '     多个触摸面板协同操作、护眼等是客户的核心需求\n' +
      '  HLZ通过采用复合材质背板搭配防爆膜，触摸面板耐受教室高频使用；支持4096级压感\n' +
      '     手写与20点触控，适配电子白板、智慧课堂平板及虚拟实验室，重塑互动教学场景\n' +
      ' ',
  },
  {
    id: 8,
    // image: require('../images/ServiceImg/Market/MarketConsumer.png'),
    alt: 'images/ServiceImg/Market/MarketConsumer.png',
    name: 'Consumer Electronic Touch Panel Solutions',
    title: '消費電子解決方案',
    subtitle: 'XXXXXXXX',
    text: 'XXXXXXXX\n' +
      '   核心需求：\n' +
      '      XXXXXXXX\n' +
      '   解决方案：\n' +
      '      XXXXXXXX\n' +
      ' ',
    describe: 'ServMarketData',
    link: 'https://touchinternational.com/applications/#top',
    time: '2025/2/13',
  },
  {
    id: 9,
    // image: require('../images/ServiceImg/Market/MarketConsumer.png'),
    alt: 'images/ServiceImg/Market/MarketConsumer.png',
    name: 'Consumer Electronic Touch Panel Solutions',
    title: '軍事領域解決方案',
    subtitle: 'XXXXXXXX',
    text: 'XXXXXXXX\n' +
      '   核心需求：\n' +
      '      XXXXXXXX\n' +
      '   解决方案：\n' +
      '      XXXXXXXX\n' +
      ' ',
    describe: 'ServMarketData',
    link: 'https://touchinternational.com/applications/#top',
    time: '2025/2/13',
  },
  {
    id: 10,
    // image: require('../images/ServiceImg/Market/MarketConsumer.png'),
    alt: 'images/ServiceImg/Market/MarketConsumer.png',
    name: 'Consumer Electronic Touch Panel Solutions',
    title: '軍事領域解決方案',
    subtitle: 'XXXXXXXX',
    text: 'XXXXXXXX\n' +
      '   核心需求：\n' +
      '      XXXXXXXX\n' +
      '   解决方案：\n' +
      '      XXXXXXXX\n' +
      ' ',
    describe: 'ServMarketData',
    link: 'https://touchinternational.com/applications/#top',
    time: '2025/2/13',
  },
]

  // {
  //   id: 6,
  //   image: require('../images/ServiceImg/Market/MarketAerospace.png'),
  //   alt: 'images/ServiceImg/Market/MarketAerospace.png',
  //   name: 'Aerospace Touch Screen Display Solutions',
  //   title: '航空航天触控面板解決方案',
  //   subtitle: '极致可靠，征服极端环境',
  //   text: '极致可靠，征服极端环境\n' +
  //          '   要求坚固耐用:\n' +
  //          '      抗冲击、宽温域(-40℃至85℃)、高亮度可视性、抗电磁干扰(EMI/RFI)\n' +
  //          '   解决方案：\n' +
  //          '      采用强化玻璃基板与光学贴合技术，确保面板在剧烈震动、极端温差及强光直射下稳定运行；通过MIL-STD军工级认证，\n' +
  //          '      支持手套及湿手操作，适配驾驶舱、航电系统等关键场景\n' +
  //          '',
  //          '合利資 設計和製造先進的航太触控螢幕顯示解決方案，並且是第一家為商用飛機製造專用触控螢幕的公司。\n' +
  //          '我們是全球領先的機上娛樂触控螢幕製造商。\n' +
  //          '合利資 遵守嚴格的 FAA 規定，為各種航空航天應用設計多點触控、易燃、高海拔、防碎触控螢幕。\n' +
  //          '我們不斷開發更薄、更輕、更智慧的触控螢幕顯示解決方案，繼續佔據產業主導地位。\n' +
  //          '除了客製化触控螢幕外，我們還為航空触控螢幕客戶提供​​完整的顯示增強功能，如陽光下可讀性、輕質模製蓋板等。\n' +
  //          '我們可以協助您找到滿足您需求的合適的 LCD，並憑藉我們的垂直製造能力提供非常經濟高效的客製化触控解決方案。\n' +
  //          '我們採用最新的被動光學膜增強技術與目前性能最高的 LED 背光技術相結合。\n' +
  //          '我們可以完成輕量級航空触控螢幕顯示器項目，並附加其他增強功能，例如客製化墊片、安全視訊驅動板、客製化邊框和背板、EMI 屏蔽等。\n' +
  //          '我們擁有完整的光學黏合能力，可以完成封裝並最大程度地提高顯示光學性能和耐用性。\n' +
  //          '我們已通過 ISO:9001 和 AS9100 認證，並在美國和亞洲擁有 10,000 級無塵室。我們在各種航空航天触控螢幕顯示器專案中擁有豐富的經驗。\n' +
  //          '航空航天触控顯示器應用：維護系統、機上娛樂、導航設備、AV 自動化控制、類比設備。\n' +
  //          '常見顯示增強功能：為了提高效能並增強航空航天應用的可用性，我們提供了廣泛的顯示器增強功能，\n' +
  //          '',
  //          '包括： EMI 屏蔽、隱私電影、防眩光膜、陽光下可讀性、防碎玻璃、防污膜\n' +
  //          '\n' +
  //   nameEng: 'Aerospace Touch Screen Display Solutions',
  //   titleEng: 'Aerospace Touch Screen Display Solutions',
  //   subtitleEng: 'Touchscreen Solutions for High-Reliability Applications',
  //   textEng: 
  //            'HLZ Technology designs and manufactures advanced aerospace touchscreen display solutions and was the first to manufacture specialized touch screens for commercial airplanes. ' +
  //            'We are the global leading manufacturer of touch screens for in-flight entertainment.' +
  //            'Adhering to the strict FAA regulations, HLZ Technology designs multi-touch, inflammable, high-altitude, shatterproof touch screens for a variety of aerospace applications' +
  //            'We continue to dominate the industry with constant development towards thinner, lighter, and smarter touch screen display solutions.' +
  //            'In addition to custom touch panels, we supply aerospace touchscreen customers with full display enhancements such as sunlight readability, lightweight molded cover lenses and more.' +
  //            'In addition to custom touch panels, we supply aerospace touchscreen customers with full display enhancements such as sunlight readability, lightweight molded cover lenses and more.' +
  //            'We can help you find the right LCD to meet your needs and provide custom touch solutions that are very cost effective thanks to our vertical manufacturing capabilities.' +
  //            'We use a combination of the latest in passive optical film enhancement technology combined with the highest-performance LED backlights available. We can complete a lightweight aerospace touchscreen display project with other enhancements such as custom gaskets, secured video driver boards, custom bezels, and backers, EMI shielding, and more. ' +
  //            'We have full optical bonding capabilities to complete the package and maximize display optics and durability.' +
  //            'We are ISO:9001 and AS9100 Certified with Class 10,000 Clean Rooms in the USA and Asia. We have extensive experience in a variety of aerospace touchscreen display projects.' +
  //            'Aerospace Touch Display Applications: Maintenance Systems, In-Flight Entertainment, Navigation Devices, AV Automation Controls, Simulation Equipment' +
  //            'Common Display Enhancements: To improve performance and enhance the usability of aerospace applications, we offer a broad range of display enhancements including:' +
  //            'EMI Shielding, Privacy Films, Anti-Glare Films, Sunlight Readability, Shatterproof Glass, Anti-Smudge Films' +
  //            '' +
  //            '',
  //   describe: 'ServMarketData',
  //   link: 'https://touchinternational.com/applications/#top',
  //   time: '2025/2/13',
  // },

  // {
  //   id: 12,
  //   image: require('../images/ServiceImg/Market/MarketMedical.png'),
  //   alt: 'images/ServiceImg/Market/MarketMedical.png',
  //   name: 'Medical Touch Screen & Touch Display Solutions',
  //   title: '醫療触控螢幕和触控顯示器解決方案',
  //   subtitle: '為醫療設備應用客製化触控螢幕、触控顯示器和触控設備製造',
  //   text:
  //     '醫療触控螢幕顯示器通常整合到醫療設備中，以實現易於使用、精確、光學清晰、重量輕和工具最少等特點。\n' +
  //     '無論是整合到手持控制設備還是手術室的液晶面板， HLZ Tech. 的客製化触控螢幕都能改善患者護理，同時滿足醫療行業設定的嚴格製造法規。\n' +
  //     '我們設計和製造可用於手術刀、指點設備、戴手套和裸指的功能片，加上防刮和防指紋蓋板、無邊框、無縫、全集成電容式多點觸摸屏。\n' +
  //     '我們是完整的醫療触控螢幕顯示問題解決者。\n' +
  //     '我們採用最新的被動光學膜增強技術與目前性能最高的 LED 背光技術相結合。\n' +
  //     '我們可以為手持設備開發輕量級解決方案，或為手術室設備等開發重型、耐磨、屏蔽設備。\n' +
  //     '我們擁有完整的光學黏合能力，可以完成封裝並最大程度地提高顯示光學性能和耐用性。\n' +
  //     '們已通過 ISO:9001 和 ISO:13485 認證，在美國和亞洲擁有 10,000 級無塵室。\n' +
  //     '們在開發完整的醫療触控螢幕顯示解決方案方面擁有數十年的綜合經驗，並且知道如何生產成功的產品。\n' +
  //     '醫療触控顯示器應用：大廳辦理入住/退房手續、病人照護監控、患者控制與溝通、手術室展示、互動目錄、實驗室分析設備\n' +
  //     '常見顯示增強功能：為了提高性能並增強手術室設備等醫療應用的可用性，HLZ Electronic 專門從事顯示器增強\n' +
  //     '包括：EMI 屏蔽、隱私電影、陽光可讀薄膜、網狀過濾器、防碎玻璃、防污膜\n' +
  //     '' +
  //     '',
  //   nameEng: 'Medical Touch Screen & Touch Display Solutions',
  //   titleEng: 'Medical Touch Screen & Touch Display Solutions',
  //   subtitleEng: 'Custom touch screens, touch displays, and touch-enabled device manufacturing for medical device applications',
  //   textEng:
  //     'Medical touchscreen displays are often integrated into medical devices for ease of use, precision, clear optics, lightweight and minimal tooling.' +
  //     'Whether it is integrated into a handheld control device or an LCD panel in the surgical room, HLZ Electronic’s custom touch screens improve patient care while meeting the stringent manufacturing regulations set by the medical industry.' +
  //     'We design and manufacture touch screens that work with scalpels, pointing devices, gloved fingers and bare fingers to multi-touch, bezel-free, seamless, fully-integrated capacitive touch screens embedded into scratch and fingerprint resistant decorated cover lens with graphics.' +
  //     'We are the complete medical touch screen display problem solver.' +
  //     'We use a combination of the latest in passive optical film enhancement technology combined with the highest-performance LED backlights available. We can develop lightweight solutions for handheld devices or heavy-duty, wear-resistant, shielded devices for operating room equipment and more.' +
  //     'We have full optical bonding capabilities to complete the package and maximize display optics and durability. We are ISO:9001 and ISO:13485 Certified with Class 10,000 clean rooms in the USA and Asia.' +
  //     'We have decades of combined experience developing complete medical touch screen display solutions and know what it takes to produce a successful product.' +
  //     'Medical Touch Display Applications: Lobby Check-In/Out, Patient Care Monitoring, Patient Controls & Communication, Surgery Room Displays, Interactive Directory, Lab Anaylsis Equipment' +
  //     'Common Display Enhancements: To improve performance and enhance the usability of medical applications such as operating room devices, HLZ Electronic specializes in display enhancements including: ' +
  //     'EMI Shielding、Privacy Films、Sunlight Readable Films、Mesh Filters、Shatterproof Glass、Anti-Smudge Films' +
  //     '' +
  //     '',
  //   describe: '',
  //   link: 'https://touchinternational.com/applications/#top',
  //   time: '2025/2/13',
  // },
  // {
  //   id: 13,
  //   image: require('../images/ServiceImg/Market/MarketPos.png'),
  //   alt: 'images/ServiceImg/Market/MarketPos.png',
  //   name: 'Retail and POS Touch Display Solutions',
  //   title: '零售和 POS 触控螢幕顯示解決方案',
  //   text:
  //     '触控螢幕廣泛應用於零售和銷售點(pos)應用，使用戶能夠簡化流程、減少人力並提供更好的客戶服務。\n' +
  //     '合利資 專門設計和製造零售和銷售點触摸屏，支援多種触控系統的多點触控、手套触控、筆輸入和簽名擷取。\n' +
  //     '零售應用範圍： 銀行自助服務終端、簽名捕獲、自助服務中心、入住/退房自助服務亭、手持/便攜式設備、銷售點設備\n' +
  //     '增強功能：為了提高零售應用程式，如POS的效能和可用性， HLZ Technology 專注於顯示器增強，\n' +
  //     '包括：紅外線濾光片、防隱私膜、防刮膜、增加貼合安全玻璃、抗陽光可讀薄膜、防爆膜...\n' +
  //     '' +
  //     '',
  //   textEng:
  //     'Touch screens are widely used in retail and point of sale (pos) applications and enable users to streamline processes, reduce manpower and provide better customer service.' +
  //     'HLZ Technology specializes in the design and manufacturing of retail and point of sale touch screens capable of multi-touch, gloved touch, pen input and signature capture for a variety of touch systems.' +
  //     'Retail Applications: Banking Kiosk, Signature Capture, Self-Service Centers, Check-In/Check-Out Kiosk, Handheld/Portable DevicesPoint of Sale Equipment' +
  //     'Enhancements: To improve performance and enhance the usability of retail applications such as point-of-sale devices, HLZ Electronic specializes in display enhancements including:' +
  //     'Infrared Filters, Privacy Films, Scratch Resistance Films, Laminated Safety Glass, Sunlight Readable Films, Impact Resistance Filters' +
  //     '' +
  //     '',
  //   describe: '' +
  //     '' +
  //     '',
  //   link: '',
  //   time: '2025/2/14',
  // },
  // {
  //   id: 14,
  //   image: require('../images/ServiceImg/Market/MarketIndustrial.png'),
  //   alt: 'images/ServiceImg/Market/MarketIndustrial.png',
  //   name: 'Industrial Touch Screen Display Solutions',
  //   title: '工業触控螢幕解決方案',
  //   text:
  //     '工業應用通常需要堅固的触控螢幕來提高通訊和效率，同時承受衝擊、振動、極端溫度和頻繁使用。\n' +
  //     'HLZ Technology 工業触控螢幕可以根據您的規格定制，以獲得最佳性能。\n' +
  //     '無論您的工業触控螢幕是否需要手套輸入功能、防水功能、EMI 屏蔽功能或更高的溫度耐受性，我們都致力於打造確保您的專案成功的触控螢幕。\n' +
  //     '除了客製化触控板外，我們還為工業触控螢幕客戶提供​​完整的顯示增強功能，例如陽光下可讀性、帶有徽標和圖形的客製化堅固覆蓋玻璃等。\n' +
  //     '我們可以協助您找到滿足您需求的合適的 LCD，並憑藉我們垂直整合的製造能力提供非常經濟高效的客製化触控解決方案。\n' +
  //     '我們可以完成加固型触控螢幕顯示專案以及其他增強功能，例如客製化墊片、安全視訊驅動板、客製化邊框和背板、EMI 濾波器等。\n' +
  //     '我們擁有完整的光學黏合能力，可以完成封裝並最大限度地提高顯示光學性能和堅固性。\n' +
  //     '我們已通過 ISO:9001 認證，並在美國和亞洲擁有 10,000 級潔淨室。\n' +
  //     '我們在各種工業触控螢幕顯示項目上擁有豐富的經驗。\n' +
  //     '工業触控顯示器應用： 工廠自動化、汽油顯示器、機械設計、無塵室處理、手持/便攜式設備、工業製造\n' +
  //     '增強功能： 為了提高性能並增強自動化触控螢幕控制等工業應用的可用性，HLZ Electronic 在顯示器方面進行了增強，\n' +
  //     '包括：夾層安全玻璃、陽光可讀薄膜、抗衝擊濾波器、隱私電影、紅外線濾光片、防刮膜\n' +
  //     '' +
  //     '',
  //   textEng:
  //     'Industrial applications often require rugged touch screens to improve communication and efficiency while withstanding shock, vibrations, temperature extremes, and heavy use.' +
  //     'HLZ Technology industrial touch screens can be customized to your specifications for optimal performance. ' +
  //     'Whether your industrial touch screen requires glove input capabilities, water resistance, EMI shielding or an increased temperature tolerance, we are committed to building touch screens that ensure your project’s success.' +
  //     'In addition to custom touch panels, we supply industrial touch screen customers with full display enhancements such as sunlight readability, custom rugged cover glass with logos and graphics and more.' +
  //     'We can help you find the right LCD to meet your needs and provide custom touch solutions that are very cost effective thanks to our vertically integrated manufacturing capabilities' +
  //     'We use a combination of the latest in passive optical film enhancement technology combined with the highest-performance LED backlights available. ' +
  //     'We have full optical bonding capabilities to complete the package and maximize display optics and ruggedization.' +
  //     'We are ISO:9001 Certified with Class 10,000 Clean Rooms in the USA and Asia.' +
  //     'We have extensive experience in a variety of industrial touch screen display projects.' +
  //     'Industrial Touch Display Applications: Factory Automation, Gasoline Displays, Mechanical Designs, Clean Room Processing, Handheld/Portable Devices, Industrial Manufacturing' +
  //     'Enhancements: To improve performance and enhance the usability of industrial applications such as automation touch screen controls, HLZ Electronic in display enhancements including: ' +
  //     'Laminated Safety Glass, Sunlight Readable Films, Impact Resistance Filters, Privacy Films, Infrared Filters, Scratch Resistance Films' +
  //     '' +
  //     '',
  //   describe: 'DITO PCap触控功能片從小尺寸到大尺寸都有全面的解決方案，並具有最大的優勢',
  //   link: 'https://touchinternational.com/applications/industrial-touch-screen/',
  //   time: '2025/2/1',
  // },
  // {
  //   id: 15,
  //   image: require('../images/ServiceImg/Market/MarketTranspotation.png'),
  //   alt: 'images/ServiceImg/Market/MarketTranspotation.png',
  //   name: 'Transportation Touch Screen Display Solutions',
  //   title: '交通運輸触控螢幕顯示解決方案',
  //   text:
  //     '運輸触控螢幕顯示解決方案適用於各種專門的應用，並能在市場上發揮至關重要的作用。\n' +
  //     'HLZ Technology 為​​越野、重型設備、船舶、車輛等提供單點触控和多點触控客製化解決方案。\n' +
  //     '當與正確的顯示增強選項搭配使用時，這些堅固的設計可以承受重型設備、公共交通系統等的日常使用和濫用。\n' +
  //     '由於行業認證和合規性要求的性能越來越高，從一開始就找到合適的合作夥伴至關重要。\n' +
  //     '交通運輸触控顯示器應用： 重型設備、GPS 導航、交通系統、票務配件、娛樂系統、海洋設備\n' +
  //     '增強功能： 為了提高性能並增強座椅娛樂等交通應用的可用性，HLZ Electronic 專注於顯示器增強，\n' +
  //     '包括：紅外線濾光片、隱私電影、耐刮濾光片、夾層安全玻璃、陽光可讀薄膜、抗衝擊濾波器\n' +
  //     '' +
  //     '',
  //     textEng:
  //     'Transportation touch screen display solutions for various specialized applications and can play a crucial role in the market.' +
  //     'HLZ Technology offers single-touch and multi-touch custom solutions for off-road, heavy equipment, marine, vehicular and more.' +
  //     'When paired with the right display enhancement options, these ruggedized designs can withstand the daily use and abuse of heavy equipment, mass-transit systems and more.' +
  //     'As industry certifications and compliance require increasingly higher performance, it is crucial to find the right partner from the beginning.' +
  //     'Transportation Touch Display Applications: Heavy Equipment, GPS Navigation, Transit Systems, Ticketing Accessories, Entertainment Systems, Marine Devices' +
  //     'Enhancements: To improve performance and enhance the usability of transportation applications such as in-seat entertainment, HLZ Electronic specializes in display enhancements including:' +
  //     'Infrared Filters, Privacy Films, Scratch Resistance Filters, Laminated Safety Glass, Sunlight Readable Films, Impact Resistance Filters' +
  //     '' +
  //     '',
  //   textx: '',
  //   describe: '',
  //   link: 'https://touchinternational.com/applications/transportation-touch-screen/',
  //   time: '2025/2/14',
  // },
  // {
  //   id: 16,
  //   image: require('../images/ServiceImg/Market/MarketMilitary.png'),
  //   alt: 'images/ServiceImg/Market/vMarketMilitary.png',
  //   name: 'Military Touchs Panel Solutions',
  //   title: '軍用触控螢幕解決方案',
  //   text:
  //     'HLZ Technology 是軍用触控螢幕顯示器設計、客製化和製造領域的業界領導者。\n' +
  //     '我們的客製化触控螢幕可以在厚手套、指點設備和裸指下工作，並且在過度振動、強烈沙塵暴、極端溫度和大氣壓力急劇變化等惡劣條件下運作。\n' +
  //     '當可靠性不是一種選擇時，選擇正確的合作夥伴至關重要。\n' +
  //     '除了客製化触控螢幕外，我們還為軍用触控螢幕客戶提供​​全面的顯示增強功能，如陽光下可讀性、夜視 (NVIS) 和雙模操作。\n' +
  //     '我們可以協助您找到符合您需求的合適 LCD，並以具有競爭力的價格購買。\n' +
  //     '我們採用最新的被動光學膜增強技術與目前性能最高的 LED 背光技術相結合。\n' +
  //     '我們可以透過其他增強功能（例如客製化墊圈、安全視訊驅動板、客製化邊框和背板、EMI 濾波器等）完成加固型触控螢幕顯示器專案。\n' +
  //     '我們擁有完整的光學黏合能力，可以完成封裝並最大限度地提高顯示光學性能和堅固性。\n' +
  //     '我們已透過 ITAR 註冊，並在各種軍用触控螢幕顯示器專案方面擁有豐富的經驗。\n' +
  //     '軍用触控螢幕顯示器應用：手持裝置、訓練設備、專用車輛、加強型 PC、導航控件\n' +
  //     'LCD 和触控螢幕增強功能：為了提高性能並增強軍事應用（如車載触控螢幕控制）的可用性，HLZ Electronic 專注於顯示器增強，\n' +
  //     '包括：EMI 屏蔽、紅外線濾光片、防眩光膜、陽光下可讀性、防碎玻璃、夜視成像\n' +
  //     '' +
  //     '',
  //   titleEng: 'Military Touchs Panel Solutions',
  //   textEng:
  //     'HLZ Technology is an industry leader in the design, customization, and manufacturing of military touchscreen displays.' +
  //     'Our custom touchscreens work with thick gloves, pointing devices, and bare fingers while performing under difficult conditions such as excessive vibration, intense dust storms, temperature extremes and dramatic changes in atmospheric pressure.' +
  //     'When reliability is not an option, choosing the right partner is critical.' +
  //     'In addition to custom touch panels, we supply military touchscreen customers with full display enhancement such as sunlight readability, night-vision (NVIS), and dual-mode operation.' +
  //     'We can help you find the right LCD to meet your needs, and source it at a competitive cost.' +
  //     'We use a combination of the latest in passive optical film enhancement technology combined with the highest-performance LED backlights available.' +
  //     'We can complete a ruggedized touchscreen display project with other enhancements such as custom gaskets, secured video driver boards, custom bezels, and backers, EMI filters, and more.' +
  //     'We have full optical bonding capabilities to complete the package and maximize display optics and ruggedization.' +
  //     'We are ITAR Registered and have extensive experience in a variety of military touchscreen display projects.' +
  //     'Military Touchscreen Display Applications: Handheld Devices, Training Equipment, Specialty Vehicles, Ruggedized PC, Navigation Controls' +
  //     'LCD and Touch Panel Enhancements: To improve performance and enhance the usability of military applications such as vehicular touchscreen controls, HLZ Electronic specializes in display enhancements including: ' +
  //     'EMI Shielding、Infrared Filters、Anti-Glare Films、Sunlight Readability、Shatterproof Glass、Night Vision Imaging' +
  //     '' +
  //     '',
  //   describe: '',
  //   link: 'https://touchinternational.com/applications/military-touch-screen/',
  //   time: '2025/2/14',
  // },
  // {
  //   id: 17,
  //   image: require('../images/ServiceImg/Market/MarketIndustrial.png'),
  //   alt: 'images/ServiceImg/Market/MarketIndustrial.png',
  //   name: '　',
  //   title: '　',
  //   text:
  //     ' \n' +
  //     '',
  //   describe: '',
  //   link: '',
  //   time: '2025/2/14',
  // },